import { DAY_OF_WEEK } from 'app/config/pad_prescription_suggestion_scheduling';
// utils
import DateFns from 'date-fns';

const checksIfMatchesDayOfWeek = function (dateTime, dayOfWeek) {
  const { SUNDAY, MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY } = DAY_OF_WEEK;

  if (dayOfWeek === SUNDAY) {
    return DateFns.isSunday(dateTime);
  }
  if (dayOfWeek === MONDAY) {
    return DateFns.isMonday(dateTime);
  }
  if (dayOfWeek === TUESDAY) {
    return DateFns.isTuesday(dateTime);
  }
  if (dayOfWeek === WEDNESDAY) {
    return DateFns.isWednesday(dateTime);
  }
  if (dayOfWeek === THURSDAY) {
    return DateFns.isThursday(dateTime);
  }
  if (dayOfWeek === FRIDAY) {
    return DateFns.isFriday(dateTime);
  }
  if (dayOfWeek === SATURDAY) {
    return DateFns.isSaturday(dateTime);
  }

  return false;
};

export default checksIfMatchesDayOfWeek;
